import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    logo: {
      src: { light: "/GG_golfglobe365_logo_black.svg", dark: "/GG_golfglobe365_logo_white.svg" },
      alt: "GolfGlobe365 GAMP",
      width: "150px",
      href: "/index",
    },
    title: "GolfGlobe365 API",
  },
  navigation: [
    {
      type: "category",
      label: "REST API",
      icon: "code",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/rest-api/authentication",
            "/guides/rate-limiting",
          ],
        },
        {
          type: "category",
          label: "Endpoints",
          icon: "terminal",
          items: [
            "/rest-api/courses",
            "/rest-api/tee-times",
            "/rest-api/pricing",
            "/rest-api/bookings",
            "/rest-api/booking-hooks",
            "/rest-api/group-bookings",
            "/rest-api/webhooks",
          ],
        },
      ],
    },
    {
      type: "category",
      label: "Guides",
      icon: "book-open",
      items: [
        "/guides/quick-start",
        "/guides/best-practices",
        "/guides/error-handling",
      ],
    },
    {
      type: "category",
      label: "SDKs (Coming Soon)",
      icon: "package",
      items: [],
    },
    {
      type: "category",
      label: "Resources",
      collapsible: false,
      icon: "link",
      items: [
        {
          type: "link",
          icon: "book",
          label: "API Reference (OpenAPI)",
          to: "/api",
        },
      ],
    },
  ],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.json",
      path: "/api",
    },
  ],
};

export default config;
